//   "https://maps.apple.com/?address=Orange%20Ave%20%26%20S%20Nova%20Rd,%20Daytona%20Beach,%20FL%20%2032114,%20United%20States&ll=29.199975,-81.037997&q=Orange%20Ave%20%26%20S%20Nova%20Rd&t=m";
// Create URLs for Google and Apple Maps
export function generateMapUrls(
    mapAddress: string,
) {
    
    let googleMapsUrl: string;
    let appleMapsUrl: string;
    // console.log(thisJob.LocationCoordinates);
    // Match shortened URLs directly for Google Maps
    if (
        mapAddress.startsWith("https://maps.app.goo.gl/") ||
        mapAddress.startsWith("https://goo.gl/maps/")
    ) {
      // console.log("shortened google urls");
      window.open(mapAddress, "_blank");
      return { googleMapsUrl: mapAddress, appleMapsUrl: mapAddress };
    }

    // Apple Maps URL patterns
    const appleLatLngMatch = mapAddress.match(
      /maps\.apple\.com\/.*?[?&]ll=([-+]?\d*\.\d+),([-+]?\d*\.\d+)/
    );
    const appleAddressMatch = mapAddress.match(
      /maps\.apple\.com\/.*?[?&]address=([^&]+)/
    );
    const appleQueryMatch = mapAddress.match(
      /maps\.apple\.com\/.*?[?&]q=([^&]+)/
    );

    // Google Maps URL patterns
    const googleLatLngMatch = mapAddress.match(
      /maps\.google\.com\/.*?q=([-+]?\d*\.\d+),([-+]?\d*\.\d+)/
    );
    const googlePlaceIdMatch = mapAddress.match(
      /maps\.google\.com\/.*?place_id=([^&]+)/
    );
    const googleDirectionsMatch = mapAddress.match(
      /maps\.google\.com\/maps\/dir\/\?api=1&destination=([^&]+)/
    );

    if (appleLatLngMatch) {
      // console.log("apple lat/long");
      const lat = appleLatLngMatch[1];
      const lng = appleLatLngMatch[2];
      googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      appleMapsUrl = `https://maps.apple.com/?ll=${lat},${lng}`;
    } else if (appleAddressMatch) {
      // console.log("apple address");
      const decodedAddress = decodeURIComponent(appleAddressMatch[1]);
      googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${decodedAddress}`;
      appleMapsUrl = `https://maps.apple.com/?q=${decodedAddress}`;
    } else if (appleQueryMatch) {
      // console.log("apple query");
      const decodedQuery = decodeURIComponent(appleQueryMatch[1]);
      googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${decodedQuery}`;
      appleMapsUrl = `https://maps.apple.com/?q=${decodedQuery}`;
    } else if (googleLatLngMatch) {
      // console.log("google lat/long");
      const lat = googleLatLngMatch[1];
      const lng = googleLatLngMatch[2];
      googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      appleMapsUrl = `https://maps.apple.com/?ll=${lat},${lng}`;
    } else if (googlePlaceIdMatch) {
      // console.log("google Place Id");
      const placeId = googlePlaceIdMatch[1];
      googleMapsUrl = `https://www.google.com/maps/place/?q=place_id:${placeId}`;
      appleMapsUrl = `https://maps.apple.com/?q=${encodeURIComponent(
        mapAddress
      )}`; // Fallback to Apple search
    } else if (googleDirectionsMatch) {
      // console.log("google directions");
      const destination = decodeURIComponent(googleDirectionsMatch[1]);
      googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
      appleMapsUrl = `https://maps.apple.com/?daddr=${destination}`;
    } else if (/^[+-]?\d+(\.\d+)?[,]\s*[+-]?\d+(\.\d+)?$/.test(mapAddress)) {
      // console.log("direct latitude,longitude coordinates");
      googleMapsUrl = `https://www.google.com/maps?q=${mapAddress}`;
      appleMapsUrl = `https://maps.apple.com/?ll=${mapAddress}`;
    } else {
      const encodedAddress = encodeURIComponent(mapAddress);
      googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      appleMapsUrl = `https://maps.apple.com/?q=${encodedAddress}`;
    }
    
    return { googleMapsUrl, appleMapsUrl };
  };


  export function parseNotes(note: string): React.ReactNode[] {
    const urlRegex = /https?:\/\/[^\s]+/g;
    const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
    const latLngRegex = /-?\d{1,3}\.\d+,\s*-?\d{1,3}\.\d+/g;
    const addressRegex =
      /\b\d{1,5}\s\w+(\s\w+){0,3}\s(?:rd|road|st|street|ave|avenue|blvd|boulevard|dr|drive|ln|lane|ct|court|pl|place)\s\w+(\s\w+){0,2}\s\w{2}\s\d{5}\b/i;
    const phoneRegex = /(?:\b\(?\d{3}\)?[-.\s]?|\b\d{3}\b)\d{3}[-.\s]?\d{4}\b/g;

    //////// used chat gpt to solve this part... generates react element for each note...  /////
    const combinedRegex = new RegExp(
      `(${urlRegex.source})|(${emailRegex.source})|(${latLngRegex.source})|(${addressRegex.source})|(${phoneRegex.source})`,
      "gi"
    );

    const elements: React.ReactNode[] = [];
    let lastIndex = 0;

    note.replace(combinedRegex, (match, ...args) => {
      const matchIndex = args[args.length - 2];
      //////////////////////////////////////////////////////////////////////////////////////
      if (lastIndex < matchIndex) {
        elements.push(
          <span key={lastIndex} style={{ color: "black"}}>{note.slice(lastIndex, matchIndex)}</span>
        );
      }

      if (urlRegex.test(match)) {
        elements.push(
          <a
            key={matchIndex}
            href={match}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black"}}
          >
            {match}
          </a>
        );
      } else if (emailRegex.test(match)) {
        elements.push(
          <a key={matchIndex} href={`mailto:${match}`} style={{ color: "black"}}>
            {match}
          </a>
        );
      } else if (latLngRegex.test(match)) {
        elements.push(
          <a
            key={matchIndex}
            href={`geo:${match}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black"}}
          >
            {match}
          </a>
        );
      } else if (addressRegex.test(match)) {
        elements.push(
          <a
            key={matchIndex}
            href={`https://maps.google.com/?q=${encodeURIComponent(match)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black"}}
          >
            {match}
          </a>
        );
      } else if (phoneRegex.test(match)) {
        elements.push(
          <a key={matchIndex} href={`tel:${match}`} style={{ color: "black"}}>
            {match}
          </a>
        );
      } else {
        elements.push(<span key={matchIndex}>{match}</span>);
      }
      ///////////////////////////////////////////////////////////////////////////////////
      lastIndex = matchIndex + match.length;
      return match; // Necessary for `replace` to function correctly
    });

    // Add remaining text after last match
    if (lastIndex < note.length) {
      elements.push(<span key={lastIndex}>{note.slice(lastIndex)}</span>);
    }
    ///////////////////////////////////////////////////////////////////////////////////////
    return elements;
  };


/////////////////////////////////////////////////////////////////////////////////////////////////
export function parseNotes2(note: string): React.ReactNode[] {
  const urlRegex = /https?:\/\/[^\s]+/g;
  const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
  const latLngRegex = /-?\d{1,3}\.\d+,\s*-?\d{1,3}\.\d+/g;
  const addressRegex =
    /\b\d{1,5}\s\w+(\s\w+){0,3}\s(?:rd|road|st|street|ave|avenue|blvd|boulevard|dr|drive|ln|lane|ct|court|pl|place)\s\w+(\s\w+){0,2}\s\w{2}\s\d{5}\b/i;
  const phoneRegex = /(?:\b\(?\d{3}\)?[-.\s]?|\b\d{3}\b)\d{3}[-.\s]?\d{4}\b/g;

  //////// used chat gpt to solve this part... generates react element for each note...  /////
  const combinedRegex = new RegExp(
    `(${urlRegex.source})|(${emailRegex.source})|(${latLngRegex.source})|(${addressRegex.source})|(${phoneRegex.source})`,
    "gi"
  );

  const elements: React.ReactNode[] = [];
  let lastIndex = 0;

  note.replace(combinedRegex, (match, ...args) => {
    const matchIndex = args[args.length - 2];
//////////////////////////////////////////////////////////////////////////////////////////////
    if (lastIndex < matchIndex) {
      elements.push(
        <span key={lastIndex}>{note.slice(lastIndex, matchIndex)}</span>
      );
    }

    if (urlRegex.test(match)) {
      elements.push(
        <a
          key={matchIndex}
          href={match}
          target="_blank"
          rel="noopener noreferrer"
          // style={{ color: "black"}}
        >
          {match}
        </a>
      );
    } else if (emailRegex.test(match)) {
      elements.push(
        <a key={matchIndex} href={`mailto:${match}`}>
          {match}
        </a>
      );
    } else if (latLngRegex.test(match)) {
      elements.push(
        <a
          key={matchIndex}
          href={`geo:${match}`}
          target="_blank"
          rel="noopener noreferrer"
          // style={{ color: "black"}}
        >
          {match}
        </a>
      );
    } else if (addressRegex.test(match)) {
      elements.push(
        <a
          key={matchIndex}
          href={`https://maps.google.com/?q=${encodeURIComponent(match)}`}
          target="_blank"
          rel="noopener noreferrer"
          // style={{ color: "black"}}
        >
          {match}
        </a>
      );
    } else if (phoneRegex.test(match)) {
      elements.push(
        <a key={matchIndex} href={`tel:${match}`}>
          {match}
        </a>
      );
    } else {
      elements.push(<span key={matchIndex}>{match}</span>);
    }
    ///////////////////////////////////////////////////////////////////////////////////
    lastIndex = matchIndex + match.length;
    return match; // Necessary for `replace` to function correctly
  });

  // Add remaining text after last match
  if (lastIndex < note.length) {
    elements.push(<span key={lastIndex}>{note.slice(lastIndex)}</span>);
  }
  ///////////////////////////////////////////////////////////////////////////////////////
  return elements;
};